import React from 'react'
import LicenseSelector from './licenseSelector'

class LicenseFixer extends React.Component {
	constructor(props) {
		super(props);
		this.initialState = {
			query: "",
			selected: "",
			initialLicenses: props.licenses ?? [],
			licenses: props.licenses ?? [],
			showErrorAlert: false,
			errorMessage: "",
			recompute: false,
			allVersions: false,
			added: [], removed: []
		}
		this.state = {...JSON.parse(JSON.stringify(this.initialState))}
		this.errorMessages = {
			noChangeToLicenses: "No changes were made to current licenses.",
			dublicates: "License already exists",
			selectLicense: "Select a license to add "
		}
		this.selectRef = React.createRef()
	}

	async setCurrentLibraryLicensesToState (library) {
		try {
			const licensesDbFormat = await window.meterian.licenses.getLicenses(library)
			const licenses = licensesDbFormat.map((license) => license.id)
			this.setState({...this.state, licenses, initialLicenses: licenses})
		} catch (e) {
			console.log(e)
			throw(e)
		}
	}
	onSelectionChange = (e) => {
		if (e.target.value === this.query) return;
		this.query = e.target.value;
		this.setState({ query: this.query })
	}

	removeLicense = (license) => {
		const licenses = [...this.state.licenses].filter(current=>current!==license)
		const added = [...this.state.added].filter(current=>license!==current)
		const removed = [...this.state.removed]
		removed.push(license)
		this.setState({...this.state,licenses, added, removed}, () => {
			if(this.isRequestValid()) this.props.setCloseModalConfirmCb(this.confirmHandler) 
			else this.props.setCloseModalConfirmCb(null)
		})
	}

	setSelected = (target) => {
		let value = target
		if(target && target.value) value = target.value
		this.setState({...this.state, selected: value})
	}

	addLicense = (e) => {
		if(!this.state.selected.length) {
			this.showErrorAlert(this.errorMessages.selectLicense)
			return
		} else if (this.state.licenses.includes(this.state.selected)) {
			this.showErrorAlert(this.errorMessages.dublicates)
			return
		}
		const licenses = [...this.state.licenses]
		const added = [...this.state.added]
		licenses.push(this.state.selected)
		added.push(this.state.selected)
		const removed = [...this.state.removed].filter(current=>this.state.selected!==current)
		this.selectRef.current.clearValue()
		this.setState({...this.state,licenses, added, removed}, (state) => {
			if(this.isRequestValid()) this.props.setCloseModalConfirmCb(this.confirmHandler) 
			else this.props.setCloseModalConfirmCb(null)
		})
	}

	async confirmLicensesChanges(changedLicenses){
		const library = this.props.licenseToFix
		const notDeleted = await this.deleteLicensesFromDb(changedLicenses.removed, {...library, version: this.state.allVersions? "*":library.version})
		const notAdded = await this.addLicensesToDb(changedLicenses.added, {...library, version: this.state.allVersions? "*":library.version})
		return { changedLicenses: changedLicenses.licenses, notAdded, notDeleted}
	}

	submitHandler = this.props.onSubmit ? this.props.onSubmit: async () => {
		if(!this.isRequestValid()) {
			this.showErrorAlert(this.errorMessages.noChangeToLicenses)
			return
		}
		try {
			window.$("#license-fix-dialog .modal-header > button").trigger("click")
			await this.props.fixLicense(this.props.licenseToFix, this.state.recompute, async()=>{
				const changedLicenses = {
					licenses: this.state.licenses,
					added: this.state.added,
					removed: this.state.removed
				}
				const currentComponent = this.props.licenseToFix
				const operationResults = await this.confirmLicensesChanges(changedLicenses)
				const updatedComponentLicenses = await window.meterian.licenses.getLicenses(currentComponent)
				return {updatedComponentLicenses, operationResults}
			})
		} catch(e) {
			throw (e)
		}
	}
	isRequestValid = () => {
		if(this.state.removed.length + this.state.added.length <= 0) {
			return false
        }
		return true
	}

	showErrorAlert = (message) => {
		this.setState({...this.state, errorMessage: message, showErrorAlert: true})
		setTimeout(() => {
			this.hideErrorAlert()
		}, 5000)
	}
	
	hideErrorAlert = () => {
		this.setState({...this.state, errorMessage: "", showErrorAlert: false})
	}
	
	async deleteLicensesFromDb (removedLicenses, library) {
		const failedDeletes = []
		for (const license of removedLicenses) {
			try{	
				await window.meterian.licenses.deleteLicense(library, license)
			}
			catch(e){
				failedDeletes.push({license, reason: e.path? e.message: "Internal error - Please contact support"}) 
			}
		}
		return failedDeletes
	}

	async addLicensesToDb (addedLicenses, library) {
		const failedAdds = []
		for (const license of addedLicenses) {
			try{
				await window.meterian.licenses.addLicense(library, license)
			}
			catch(e){
				failedAdds.push({license, reason: e.path? e.message: "Internal error - Please contact support"}) 
			}
		}
		return failedAdds
	}


	getSnapshotBeforeUpdate(previousProps) {
        return previousProps.licenseToFix !== this.props.licenseToFix
    }

    componentDidUpdate(prevProps,prevState,didUpdate){
        if ( ! didUpdate ) return
		this.setState({...JSON.parse(JSON.stringify(this.initialState))})
		if(Object.keys(this.props.licenseToFix).length) this.setCurrentLibraryLicensesToState(this.props.licenseToFix)
		window.$("#license-fix-dialog").off("hidden.bs.modal").on("hidden.bs.modal",()=>{
			this.props.setLicenseToFix()
			this.setState({...JSON.parse(JSON.stringify(this.initialState))})
		})
		
    }

	confirmHandler() {
		window.$("#license-fix-dialog").modal("hide")
	}
	render() {
		const { licenseToFix } = this.props;
		
		return (
			<div className="modal fade user-modal" id="license-fix-dialog" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						
						<div id="alert-modal" style={{ display: 'none' }}>
							<br />
							<div className="alert alert-danger">
								<strong><span id="alert-modal-message"></span></strong>
								<span href="#" className="close" data-hide="alert">&times;</span>
							</div>
						</div>

						<div className="modal-header">
							<h4 className="modal-title" id="license-fix-title">{licenseToFix.title}</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>

						<div className="modal-body">
							<strong>Current Licenses:</strong>
							{this.state.licenses.length ? <div className='license-badge-container'>
								{this.state.licenses.map((license, index) => {
									return <div key={`${index}-license`} className='license-badge badge-light'>
										<span data-testid="license-name">{license}</span>
										<span className="license-remove-badge" data-index={index} data-testid="remove-license" onClick={() => this.removeLicense(license)}>&times;</span>
									</div>
								})}
							</div>: <div className='license-badge-container'>No licenses added to selection</div>
							}
							<div role="form" onKeyUp={this.onSelectionChange}>
								<strong>Select the license:</strong>
								<div className="form-horizontal">
									<div className='license-fixer-select-container'>						
										<LicenseSelector selectRef={this.selectRef} query={this.state.query} setSelected={this.setSelected} licenseToFix={licenseToFix}/>
										<button type='button' className='btn btn-primary ml-2' onClick={this.addLicense}>Add</button>
									</div>
									<input type="checkbox" id="recumpute-checkbox" data-testid="recumpute-checkbox" style={{cursor: "pointer"}} onChange={(e) => this.setState({...this.state, recompute: !this.state.recompute})} checked={this.state.recompute}></input>
									<label htmlFor="recumpute-checkbox" style={{marginLeft: "5px", cursor: "pointer"}}>Automatically recompute the report</label>
									<br/>
									<input type="checkbox" id="all-versions-checkbox" data-testid="all-versions-checkbox" style={{cursor: "pointer"}} onChange={(e) => this.setState({...this.state, allVersions: !this.state.allVersions})} checked={this.state.allVersions}></input>
									<label htmlFor="all-versions-checkbox" style={{marginLeft: "5px", cursor: "pointer"}}>Apply to all versions of this component</label>
								</div>
							</div>
							{this.state.showErrorAlert ? 
                                    <div id="alert-modal">
                                        <div className="d-flex justify-content-between alert alert-danger ">
                                            <strong><span id="alert-modal-message" data-testid="error-message">{this.state.errorMessage}</span></strong>
                                            <button href="#" className="close ml-1" data-hide="alert" data-testid="close-error-message" onClick={this.hideErrorAlert} style={{pointerEvents: "all"}}>&times;</button>
                                        </div>
                                    </div>: ""
                                }
						</div>
						
						<div className="modal-footer">
							<button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
							<button type="button" disabled={this.state.submitBtnDisabled} className="btn btn-primary" data-testid="form-submit" onClick={() => this.submitHandler(this.state.licenses)} >Confirm</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


export default LicenseFixer